import {create} from "zustand";

interface StateTypeState {
  stateValue: string;
  setStateValue: (value: string) => void;
  stateCompValue: string[];
  setStateCompValue: (value: string[]) => void;
  stateList: string[];
}

const useStateType = create<StateTypeState>((set) => ({
  stateValue: "All",
  setStateValue: (value: string) => set(() => ({stateValue: value})),
  stateCompValue: ["All", "Alaska"],
  setStateCompValue: (value: string[]) => set(() => ({stateCompValue: value})),
  stateList: [
    "All",
    "Alaska",
    "Alabama",
    "Arkansas",
    "Arizona",
    "California",
    "Colorado",
    "Connecticut",
    "District of Columbia",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Iowa",
    "Idaho",
    "Illinois",
    "Indiana",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Massachusetts",
    "Maryland",
    "Maine",
    "Minnesota",
    "Missouri",
    "Mississippi",
    "Montana",
    "North Carolina",
    "North Dakota",
    "Nebraska",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "Nevada",
    "New York",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Virginia",
    "Vermont",
    "Washington",
    "Wisconsin",
    "West Virginia",
    "Wyoming",
  ],
}));

export default useStateType;
